// src/components/profile/sections/SectionWrapper.jsx
import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const SectionWrapper = ({ 
  children, 
  title, 
  index, 
  sectionLayout, 
  showSectionIcons, 
  showSectionNumbers, 
  enableSectionCollapse, 
  icon, 
  layout 
}) => {
  const [collapsed, setCollapsed] = useState(false);

  const getSectionClasses = () => {
    const base = 'section-wrapper';
    const layoutClasses = {
      card: 'bg-white rounded-xl border border-gray-200 p-6 shadow-sm',
      list: 'bg-white border-l-4 border-purple-500 p-6 pl-8 mb-6',
      timeline: 'relative pl-8 pb-8 border-l-2 border-gray-200 ml-4',
      grid: 'bg-white rounded-lg border border-gray-200 p-4'
    };
    
    const shadowClass = 'shadow-[var(--profile-shadow,0_1px_3px_0_rgba(0,0,0,0.1))]';
    const radiusClass = 'rounded-[var(--profile-border-radius,8px)]';
    
    return `${base} ${layoutClasses[sectionLayout] || layoutClasses.card} ${shadowClass} ${radiusClass}`;
  };

  const renderSectionHeader = () => (
    <div 
      className={`section-header flex items-center justify-between mb-6 ${
        enableSectionCollapse ? 'cursor-pointer' : ''
      }`} 
      onClick={enableSectionCollapse ? () => setCollapsed(!collapsed) : undefined}
    >
      <h2 className="text-xl font-semibold text-gray-900 flex items-center gap-3">
        {showSectionNumbers && (
          <span className="w-8 h-8 rounded-full bg-purple-100 text-purple-600 flex items-center justify-center text-sm font-medium">
            {index + 1}
          </span>
        )}
        {showSectionIcons && icon}
        {title}
      </h2>
      {enableSectionCollapse && (
        <button className="p-1 hover:bg-gray-100 rounded">
          <ChevronDown className={`h-4 w-4 transition-transform ${collapsed ? 'rotate-180' : ''}`} />
        </button>
      )}
    </div>
  );

  if (sectionLayout === 'timeline') {
    return (
      <div className={getSectionClasses()}>
        <div className="absolute w-3 h-3 bg-purple-500 rounded-full -left-2 top-2"></div>
        {renderSectionHeader()}
        {(!enableSectionCollapse || !collapsed) && children}
      </div>
    );
  }

  return (
    <div className={getSectionClasses()}>
      {renderSectionHeader()}
      {(!enableSectionCollapse || !collapsed) && children}
    </div>
  );
};

export default SectionWrapper;